module.exports = __webpack_public_path__ + "img/foodtype-mexican.763e8116.png";